export default "__VITE_ASSET__CEEtYbPJ__"